// Following the established OwnersPage pattern
import { useState } from "react";
import {
  Box,
  Heading,
  VStack,
  Alert,
  AlertIcon,
  Center,
  Spinner,
  AlertTitle,
  AlertDescription,
} from "@chakra-ui/react";
import AuditFilters from "../../components/features/audit/AuditFilters/AuditFilters";
import AuditTable from "../../components/features/audit/AuditTable/AuditTable";
import AuditPaginator from "../../components/features/audit/AuditPaginator/AuditPaginator";
import { useAuditTrail } from "../../hooks/useAuditTrail";
import { isUserAdmin } from "../../lib/supabase";
import { useQuery } from "@tanstack/react-query";
import type { AuditFilters as AuditFiltersType } from "../../types";

export function AuditTrailPage() {
  const [filters, setFilters] = useState<AuditFiltersType>({
    page: 1,
    limit: 50,
    search: "",
    sortBy: "timestamp",
    sortOrder: "desc",
    showDeleted: false,
  });

  // Check admin status (following established pattern)
  const { data: isAdmin, isLoading: isCheckingAdmin } = useQuery({
    queryKey: ["admin-status"],
    queryFn: isUserAdmin,
    retry: 1,
  });

  const { data, isLoading, error } = useAuditTrail(filters);

  if (isCheckingAdmin) {
    return (
      <Center p={8} minH="200px">
        <Spinner size="xl" color="blue.500" thickness="4px" />
      </Center>
    );
  }

  if (!isAdmin) {
    return (
      <Center p={8} minH="200px">
        <Alert
          status="warning"
          variant="subtle"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          textAlign="center"
          borderRadius="lg"
          p={6}
          maxW="md"
        >
          <AlertIcon boxSize="40px" mr={0} />
          <AlertTitle mt={4} mb={1} fontSize="lg">
            Acesso Restrito
          </AlertTitle>
          <AlertDescription maxWidth="sm">
            Você não tem permissão para acessar a trilha de auditoria. Esta
            seção é apenas para administradores.
          </AlertDescription>
        </Alert>
      </Center>
    );
  }

  return (
    <Box p={6}>
      <VStack spacing={6} align="stretch">
        <Heading>Trilha de Auditoria</Heading>

        <AuditFilters filters={filters} onFiltersChange={setFilters} />

        <AuditTable
          data={data?.data || []}
          isLoading={isLoading}
          error={error}
        />

        <AuditPaginator
          filters={filters}
          onFiltersChange={setFilters}
          pagination={data}
        />
      </VStack>
    </Box>
  );
}
